import { render } from "./TestResultSuggestion.vue?vue&type=template&id=0b7dbac0&scoped=true"
import script from "./TestResultSuggestion.vue?vue&type=script&lang=js"
export * from "./TestResultSuggestion.vue?vue&type=script&lang=js"

import "./TestResultSuggestion.vue?vue&type=style&index=0&id=0b7dbac0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7dbac0"]])

export default __exports__